import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const UserUpdate = ({ user, token, updateUser }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [birthday, setBirthday] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = {
      Username: username,
      Password: password,
      Email: email,
      Birthday: birthday,
    };

    fetch(`https://filmflix-api.herokuapp.com/users/${user.Username}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          toast.error("Changing userdata failed", {
            autoClose: 2000,
            hideProgressBar: true,
          });
          return false;
        }
      })
      .then((user) => {
        if (user) {
          toast.success("Successfully changed userdata", {
            autoClose: 2000,
            hideProgressBar: true,
          });
          updateUser(user);
        }
      })
      .catch((e) => {
        toast.error(e);
      });
  };

  return (
    <>
      <h3 className="mb-3">Update information</h3>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Username:</Form.Label>
          <Form.Control
            type="text"
            className= "rounded-0"
            placeholder="Must have at least 3 characters"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            minLength="5"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Password:</Form.Label>
          <Form.Control
            type="password"
            value={password}
            className= "rounded-0"
            placeholder="Must have at least 6 characters"
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength="8"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Email:</Form.Label>
          <Form.Control
            type="email"
            className= "rounded-0"
            placeholder="Must be a valid email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="mb-3">Birthday:</Form.Label>
          <Form.Control
            type="date"
            className= "rounded-0"
            value={birthday}
            onChange={(e) => setBirthday(e.target.value)}
            required
          />
        </Form.Group>
        <Button className="mt-4 btn-secondary" type="submit">
          Update
        </Button>
      </Form>
    </>
  );
};

// validate with propTypes

UserUpdate.propTypes = {
  token: PropTypes.string.isRequired,
  updateUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    Username: PropTypes.string.isRequired,
    Password: PropTypes.string.isRequired,
    Email: PropTypes.string.isRequired,
    Birthday: PropTypes.string.isRequired,
  }).isRequired,
};
